

import cryptoUtils from "../utils/utils";

/**
 * https://github.com/GalaChain/sdk/blob/main/chain-api/src/validators/IsUserAlias.ts
 * https://github.com/GalaChain/sdk/blob/main/chain-api/src/validators/IsUserAlias.spec.ts
 */
export default {
  isValidAddress(address, currency, networkType) {
      
    if (typeof address !== "string" || address.length === 0) {
      return false;
    }

    const parts = address.split("|");

    if (parts.length === 1) {
        return this.isValidSystemUser(parts[0]);
    }

    if (parts.length === 2) {
      const [prefix, value] = parts;

      if ((prefix === "client" || prefix === "service") && value.length > 0) {
        return true;
      }
  
      if (prefix === "eth") {
        return this.isChecksumedEthAddress(value);
      }
    }

    return false;

  },
  isValidSystemUser(value) {
    return value === "EthereumBridge" || value === "TonBridge" || /^GalaChainBridge-\d+$/.test(value);
  },
  isChecksumedEthAddress(address) {
    if (!/^(0x)?[0-9a-fA-F]{40}$/.test(address)) {
      return false;
    }

    const nonPrefixed = address.slice(-40);

    return this.checksumedEthAddress(nonPrefixed.toLowerCase()) === nonPrefixed;
  },
  // the function below to calculate checksumed address is adapted from ethers.js
  // see: https://github.com/ethers-io/ethers.js/blob/main/src.ts/address/address.ts
  checksumedEthAddress(addressLowerCased) {
    const chars = addressLowerCased.split("");

    const expanded = new Uint8Array(40);
    for (let i = 0; i < 40; i++) {
      expanded[i] = chars[i].charCodeAt(0);
    }

    const hashed = cryptoUtils.keccak256Digest(expanded);

    for (let i = 0; i < 40; i += 2) {
      if (hashed[i >> 1] >> 4 >= 8) {
        chars[i] = chars[i].toUpperCase();
      }
      if ((hashed[i >> 1] & 0x0f) >= 8) {
        chars[i + 1] = chars[i + 1].toUpperCase();
      }
    }

    return chars.join("");
  }
};
